import DodoneContext from 'app/dodones/Context'
import Modal from 'app/components/Modal'
import useModal from 'app/components/useModal'
import EditAttribute from 'app/dodones/edit/Attribute'
import update from 'immutability-helper'

export default ({ children, attributesNames = [], className = '' }) => {
  const { dodone, updateDodone } = useContext(DodoneContext)
  const { open, close, isOpen, setIsOpen } = useModal(false)
  const [changeSet, setChangeSet] = useState({})

  const attributeMap = useMemo(() => {
    let names = attributesNames

    if (typeof attributesNames.forEach != 'function') names = [attributesNames]

    const newAttributeMap = {}
    names.forEach((name) => {
      newAttributeMap[name] = dodone.getAttribute(name)
    })

    return newAttributeMap
  }, [dodone, attributesNames])

  useEffect(() => {
    const initialChangeSet = {}

    Object.values(attributeMap).forEach((attribute) => {
      initialChangeSet[attribute.name] = dodone[attribute.name]
    })

    initialChangeSet.changeCount = 0
    setChangeSet(initialChangeSet)
  }, [dodone])

  const onChange = useCallback((attributeName, value) => {
    setChangeSet((previousChangeSet) => {
      return update(previousChangeSet, {
        [attributeName]: {
          $set: value
        }
      })
    })
  }, [])

  const save = useCallback(() => {
    updateDodone.mutate(
      {
        attributes: changeSet
      },
      {
        onSettled: () => {
          close()
        }
      }
    )
  })

  return (
    <>
      <Modal isOpen={isOpen} close={close} header={`Edit Dodone`}>
        <div className="fcol flex-1 bottom-bordered-list gap-2">
          {Object.entries(attributeMap).map(([name, attribute]) => {
            return (
              <EditAttribute
                key={name}
                onChange={onChange}
                attribute={attribute}
                value={changeSet[attribute.name]}
              />
            )
          })}
        </div>
        <div className="btn btn-primary" onClick={save}>
          Save
        </div>
      </Modal>
      <div onClick={open} className={className}>
        {children}
      </div>
    </>
  )
}
